export default "__VITE_ASSET__afe472e0__"